export default () => {
    return [
        {
            path: '/monitoraggio',
            name: 'monitoraggio',
            component: () => import('./views/monitoraggio.vue'),
        },
    ];
};
